import { render, staticRenderFns } from "./AdditionalMediaConfigItem.vue?vue&type=template&id=330226b4&scoped=true&"
import script from "./AdditionalMediaConfigItem.vue?vue&type=script&lang=js&"
export * from "./AdditionalMediaConfigItem.vue?vue&type=script&lang=js&"
import style0 from "./materialOwnSource.styl?vue&type=style&index=0&id=330226b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330226b4",
  null
  
)

export default component.exports